export default __webpack_public_path__ + "static/1-341de98345a713888ea060076b2698be.jpeg";